const CRLF = '\r\n';
const encoder = new TextEncoder();
export async function writeCommand(transport, command) {
    return transport.write(encoder.encode(`${command}${CRLF}`));
}
export const commandInfo = () => 'info';
export const commandVersion = () => 'version';
export const commandSweep = (p) => `sweep ${p.start} ${p.stop} ${p.points}`;
export const commandData0 = () => 'data 0';
export const commandData1 = () => 'data 1';
export const commandResume = () => 'resume';
export const commandPause = () => 'pause';
//# sourceMappingURL=command-writer.js.map